import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { MATERIAL_TYPE_PHYSICAL } from '../../../constants/BibConstants';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { TransactionalButton } from '@bibliocommons/base-buttons';
import ScreenReaderItemInfo from '@bibliocommons/shared-screen-reader-item-info';

class RequestItemButton extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleClick');
  }

  handleClick() {
    if (this.props.availableForCheckout && this.props.materialType !== MATERIAL_TYPE_PHYSICAL) {
      this.props.handleCheckoutClick(this.props.metadataId);
    } else {
      this.props.handleHoldClick(this.props.metadataId);
    }
  }

  getDataKey() {
    if (this.props.materialType === MATERIAL_TYPE_PHYSICAL) {
      return 'place-a-hold';
    }
    if (this.props.availableForCheckout) {
      return 'checkout-now';
    }
    return 'request-this-download';
  }

  renderButtonText() {
    if (this.props.materialType === MATERIAL_TYPE_PHYSICAL) {
      return <FormattedMessage id="btn.placeAHold" />;
    }
    if (this.props.availableForCheckout) {
      return <FormattedMessage id="check_out_now" />;
    }
    return <FormattedMessage id="request_this_title" />;
  }

  render() {
    const { format, title, authors, serviceAvailable, titleNotOwned } = this.props;
    return (
      <TransactionalButton
        handleClick={this.handleClick}
        className="cp-request-item-button"
        isLoading={this.props.isLoading}
        block
        disabled={!serviceAvailable || titleNotOwned}
        data-test-id={`request-item-${this.props.metadataId}`}
        dataKey={`bib-${this.getDataKey()}`}>
        { this.renderButtonText() }
        <ScreenReaderItemInfo format={format} title={title} authors={authors} />
      </TransactionalButton>
    );
  }
}

RequestItemButton.propTypes = {
  handleCheckoutClick: PropTypes.func.isRequired,
  handleHoldClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  availableForCheckout: PropTypes.bool,
  materialType: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  authors: ImmutablePropTypes.listOf(React.PropTypes.string),
  treatAsItemLevelHold: PropTypes.bool,
  metadataId: PropTypes.string.isRequired,
  titleNotOwned: PropTypes.bool
};

export default RequestItemButton;



// WEBPACK FOOTER //
// ./app/components/shared/RequestItemButton/RequestItemButton.jsx